<template>
  <div class="mode-free-spells">
    <div class="block-title h-outer-border around-4 bw2 bz0 h-bg brown-2">
      <div class="label">英雄魔法</div>
      <div class="tools">
        <div class="btn h-title nowrap" data-title="选择所有魔法" v-click-sound-button @click="handleSelectAll">全选</div>
        <div class="btn h-title nowrap" data-title="取消选择所有魔法" v-click-sound-button @click="handleUnSelectAll">清空</div>
      </div>
      <div class="info">
        魔法总数：{{ total }}
      </div>
    </div>
    <div class="spells">
      <div class="class-spells h-outer-border around-4 bw2 bz0 h-bg brown-2" v-for="classSpells in spells">
        <img class="spell-level lt" :class="[classSpells.spellClass]"
             :src="`${$rHost}/img/spell/level/${classSpells.spellClass}.png`"
             alt="">
        <img class="spell-level rt" :class="[classSpells.spellClass]"
             :src="`${$rHost}/img/spell/level/${classSpells.spellClass}.png`"
             alt="">
        <img class="spell-level lb" :class="[classSpells.spellClass]"
             :src="`${$rHost}/img/spell/level/${classSpells.spellClass}.png`"
             alt="">
        <img class="spell-level rb" :class="[classSpells.spellClass]"
             :src="`${$rHost}/img/spell/level/${classSpells.spellClass}.png`"
             alt="">

        <div class="spell-item h-outer-border around-4 bw2 bz0 h-bg brown-1"
             :class="{selected: item.select, invalid: item.level > maxLevel}"
             :title="item.level > maxLevel ? '智慧术等级不足' : ''"
             v-for="item in classSpells.list"
             v-click-sound-button
             @click="handleToggle(item)">
          <img class="spell-icon" :src="`${$rHost}/img/spell/${item.name}.png`" alt="">
          <img v-if="item.select" class="select-icon" :src="`${$rHost}/img/btn/TPTHCHKG.png`" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import spells from '../data/spells'

  export default {
    name: 'spells',

    data () {
      return {
        spells: [],
      }
    },

    props: {
      initSpells: {
        type: Array,
        default () {
          return null
        }
      },
      wisdomLevel: {
        type: Number,
        default: 0,
      }
    },

    watch: {
      initSpells (val) {
        if (val) {
          this.spells.forEach((spell) => {
            spell.list.forEach((d) => {
              d.select = this.initSpells.includes(d.name)
            })
          })
        }
      },
    },

    computed: {
      total () {
        return this.spells.map((d) => d.list.map((d) => d.select)).flat().reduce((a, b) => a + b, 0)
      },

      maxLevel () {
        return [2, 3, 4, 5][this.wisdomLevel || 0] || 2
      },
    },

    mounted () {
      this.spells = JSON.parse(JSON.stringify(spells))
    },

    methods: {
      getSpells () {
        return JSON.parse(JSON.stringify(this.spells))
      },

      handleToggle (item) {
        item.select = !item.select
      },

      handleUnSelectAll () {
        this.spells.forEach((s) => {
          s.list.forEach((d) => d.select = false)
        })
      },

      handleSelectAll () {
        this.spells.forEach((s) => {
          s.list.forEach((d) => d.select = true)
        })
      },
    }
  }
</script>

<style lang="stylus" scoped>
  $slPadding = -3px

  .block-title
    display flex
    align-items center
    margin-bottom 5px
    padding 2px 7px
    line-height 24px
    font-size 12px
    whiteText1()
    .label
      flex-grow 1
      letter-spacing 1px
      goldText()
    .info
      width 82px
      text-align right
      cursor help
      &:after
        width 150px

  .spells
    display flex
    flex-direction column

  .spell-level
    position absolute
    z-index 1
    width 26px
    transform-origin center
    &.earth
      width 30px
    &.lt
      left $slPadding
      top $slPadding
      transform scale(1, -1)
    &.rt
      right $slPadding
      top $slPadding
      transform scale(-1, -1)
    &.lb
      left $slPadding
      bottom $slPadding
    &.rb
      right $slPadding
      bottom $slPadding
      transform scale(-1, 1)

  .class-spells
    position relative
    display inline-flex
    flex-direction row
    flex-wrap wrap
    padding 10px 8px
    user-select none
    &:not(:last-child)
      margin-bottom 15px
    .spell-item
      position relative
      display flex
      justify-content center
      align-items center
      margin 2px
      padding 5px
      width 65px
      height 50px
      .select-icon
        position absolute
        z-index 1
        right 3px
        bottom 3px
        width 20px
        filter drop-shadow(1px 1px 1px #000)
      .spell-icon
        width 100%
        filter grayscale(1)
      &:hover
        outline 1px solid $colorWhite
        cursor pointer
        .spell-icon
          filter grayscale(0.4)
      &.selected
        outline 1px solid $colorGold
        .spell-icon
          filter grayscale(0)
        &.invalid
          outline 1px solid $colorRed
          .select-icon,
          .spell-icon
            filter grayscale(1)

  .tools
    position relative
    padding 0 10px
    display flex
    .btn
      padding 0 2px
      line-height 24px
      letter-spacing 1px
      user-select none
      color $colorGold
      opacity 0.75
      &:not(:last-child)
        margin-right 5px
      &:hover
        opacity 1
        color $colorGold
        cursor pointer
      &:active
        opacity 1
        color darken($colorGold, 15%)
</style>
